import Loading from 'components/Loading';
import Select from 'components/Select';
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class ServiceSelect extends Component {
  static propTypes = {
    onSelect: PropTypes.func.isRequired,
    getServices: PropTypes.func.isRequired,
    services: PropTypes.instanceOf(Map).isRequired,
    taxAuthorityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  };

  state = {
    selectedService: null,
  };

  componentDidMount() {
    const { services, taxAuthorityId, getServices } = this.props;
    const data = services.get('data');
    if (!data || !data.get(`${taxAuthorityId}`)) {
      getServices(taxAuthorityId);
    }
  }

  componentDidUpdate({ taxAuthorityId: prevTaxAuthorityId }) {
    const { services, taxAuthorityId, getServices } = this.props;
    const isNewId = `${prevTaxAuthorityId}` !== `${taxAuthorityId}`;

    const data = services.get('data');
    if (isNewId && (!data || !data.get(taxAuthorityId))) {
      getServices(taxAuthorityId);
    }
  }

  getServicesOptions = () => {
    const { services, taxAuthorityId } = this.props;
    const service = services.getIn(['data', `${taxAuthorityId}`]) || [];
    return service
      .map((item) => {
        const children = item.children ? item.children.service || [] : [];
        let option = null;

        if (children.length) {
          option = {
            label: item.name,
            options: children.map((childItem) => {
              return {
                label: childItem.name,
                value: childItem.id,
              };
            }),
          };
        }
        return option;
      })
      .filter((option) => option !== null);
  };

  findService = (id) => {
    const { services, taxAuthorityId } = this.props;
    const servicesGroups = services.getIn(['data', `${taxAuthorityId}`]) || [];
    let service = null;

    for (const group of servicesGroups) {
      const items = group.children ? group.children.service || [] : [];
      service = items.find((item) => +item.id === +id);
      if (service) {
        break;
      }
    }

    return service;
  };

  onSelectService = (service) => {
    this.setState({ selectedService: service }, () => {
      this.props.onSelect(this.findService(service.value));
    });
  };

  hasData = () => {
    const { services, taxAuthorityId } = this.props;
    const service = services.getIn(['data', `${taxAuthorityId}`]);

    return !!service;
  };

  isLoading = () => {
    const { services } = this.props;
    return services.get('loading');
  };

  renderSelect = () => {
    if (!this.hasData()) {
      return null;
    }

    const { selectedService } = this.state;
    const options = this.getServicesOptions();

    return (
      <Select
        key={'123'}
        label="Выберите услугу или тему *"
        options={this.getServicesOptions()}
        value={selectedService}
        placeholder="Выберите цель записи на прием"
        noResultsMessage="Не найдено ни одной доступной услуги"
        onChange={this.onSelectService}
        isFull={true}
        isDisabled={!options.length}
      />
    );
  };

  renderLoading = () => {
    return (
      <div className="loading-container loading-container__big">
        <Loading />
      </div>
    );
  };

  render() {
    return this.isLoading() ? this.renderLoading() : this.renderSelect();
  }
}
